<template>
    <v-row no-gutters class="gallery-imgs">
        <v-col cols="12" xl="10" order-xl="2">
            <div class="pl-xl-20">
                <div class="gallery-imgs__img">
                    <v-tabs-items :value="selectedIndex">
                        <v-tab-item v-for="(img, index) in imgs" :key="img._id" :value="index">
                            <auction-imgs-overlay :imgs="imgs">
                                <template #activator="{ attrs, on, setIndex }">
                                    <v-img contain :src="img.url" :aspect-ratio="1 / 1" width="100%" max-width="540px" v-bind="attrs" v-on="on" @click="setIndex(img)" class="grey-ef" />
                                </template>
                            </auction-imgs-overlay>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </div>
        </v-col>
        <v-col cols="12" xl="2" order-xl="1">
            <div class="gallery-imgs__thumb-wrap">
                <div v-for="(img, index) in imgs" :key="img._id" @mouseenter="setSelectedIndex(img)" :class="{ 'active' : selectedIndex == index }" class="gallery-imgs__thumb">
                    <v-img contain :src="img.url" :aspect-ratio="1 / 1" width="100%" class="grey-ef" />
                </div>
            </div>
            <!-- <div v-for="(img, index) in imgs" :key="img._id" @mouseenter="setSelectedIndex(img)" class="gallery-imgs">
                <v-fade-transition>
                    <v-overlay v-show="selectedIndex == index" absolute z-index="0" opacity="0" />
                </v-fade-transition>
                <v-img :src="img.url" :aspect-ratio="1 / 1" width="100%" />
            </div> -->
        </v-col>
    </v-row>
</template>

<script>
import auctionImgsOverlay from "./auction-imgs-overlay.vue";
export default {
    components: { auctionImgsOverlay },
    props: ["imgs"],
    data: () => ({
        selectedIndex: 0,
    }),
    methods: {
        setSelectedIndex({ _id }) {
            this.selectedIndex = this.imgs.findIndex((img) => img._id == _id);
        },
    },
};
</script>

<style>
</style>